<template>

<div class="content-wrapper" v-bind:class="{'is-empty': empty, 'is-no-results': noResults}">

	<slot></slot>

	<div class="content-wrapper-loading" v-if="loading && !isBuilding"><i class="fa fa-spin fa-spinner"></i></div>

	<div class="action-box" v-if="loading && isBuilding" v-bind:style="{'marginLeft': window.menuIndentContent}">

        <div class="action-icon">
            <dotlottie-player src="https://lottie.host/a3d14eb0-2885-4f16-a1ae-440207319a9c/FIjntGcdjQ.json" background="transparent" speed="1" style="width: 192px; height: 192px;" loop autoplay></dotlottie-player>
        </div>

        <div class="action-title">Building index<small>Please wait...</small></div>

        <div class="action-description">This is the first time you have viewed your index and may take a minute or two.</div>

    </div>

</div>

</template>

<script>

export default {

	props: ['empty', 'noResults', 'loading', 'isBuilding']

}

</script>

<style scoped>

.content-wrapper {
	width: 100%;
}

.content-wrapper-loading {
	position: fixed;
	left: calc(50% + 160px);
	top: calc(50% + 88px);
	transform: translate(-50%, -50%);
	color: #ffc563;
	font-size: 48px;
}

.is-small .content-wrapper-loading {
	left: 50%;
}

.action-box {
    max-width: 640px;
    width: calc(100% - 20px);
    text-align: center;
	position: fixed;
	left: calc(50% + 160px);
	top: calc(50% + 88px);
	transform: translate(-50%, -50%);
	transition: margin-left 100ms linear;
}

.action-icon {
    height: 192px;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.action-title {
    font-size: 24px;
    font-weight: 500;
    color: #082534;
    margin-bottom: 20px;
}

.action-title small {
    display: block;
    font-size: 16px;
    margin-top: 4px;
    color: #333;
    font-weight: 300;
}

.action-description {
    font-size: 16px;
    line-height: 20px;
    color: #244657;
    font-weight: 300;
    background-color: #33CCCC;
    padding: 18px 20px;
    border-radius: 4px;
}

.action-description:before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: -7px;
    margin-left: -8px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent #33CCCC transparent;
    transform: rotate(0deg);
}

</style>
